import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function ClosingStatement() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.2);
  return <section ref={ref} className={`w-full py-10 md:py-12 lg:py-16 px-6 md:px-12 lg:px-20 bg-white border-b border-gray-200 scroll-animate ${isVisible ? 'visible' : ''}`} data-id="element-15">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-16">
        <h3 className="text-[20px] md:text-[24px] lg:text-[28px] font-bold text-brand-teal leading-[1.4] mb-6" data-id="element-17">
          Why This Matters (And Why Now)
        </h3>

        <div className="text-[16px] text-brand-navy font-normal leading-[1.8] space-y-4 text-left md:text-center" data-id="element-18">
          <p data-id="element-19">
            Understanding these five mechanisms explains your child's skin. It
            explains defective expensive creams. It explains why cheap filters
            didn't work.
          </p>
          <p data-id="element-20">
            But understanding the problem is step one. Step two is{' '}
            <strong data-id="element-21">addressing it at the source</strong>.
          </p>
          
        </div>
      </div>
    </section>;
}